import { createContext, useContext, useLayoutEffect, useRef,  } from 'react'

import { localAccessors } from '@utils/localStateAccess'
import usePostStatsContext from './postStatsContext'
import useCheckButton from '@hooks/useCheckButton'
import useModalContext from './modalContext'
import useFeed from '@hooks/useFeed';

const NearbyFeedContext = createContext();
const NearbyFeedProvider = ({ children }) => {
  const { nearbyFeed } = localAccessors
  const postStats = usePostStatsContext()
  const { setNewPostCallbackRef } = useModalContext()
  const firstProviderRender = useRef(true)

  //// NEARBY FEED CONFIG
  const nearbyFeedRef = useRef()
  // Feed State/Utilities
  const nearbyFeedState = useFeed({ getPostsUrl: '/api/feeds/nearby_posts', feedAccessor: nearbyFeed(), postStats })
  // CheckPostButton state
  const nearbyCheckPostsButton = useCheckButton({ getDataOnClick: nearbyFeedState.getPosts })

  // sets timeout for check posts button on initial render
  useLayoutEffect(() => {
    if (firstProviderRender.current) {
      nearbyCheckPostsButton.setCheckPostsTimeout(10000)
      firstProviderRender.current = false
    }
  }, [])

  // TODO: this needs to change
  useLayoutEffect(() => {
    setNewPostCallbackRef((newPost) => {
      if (newPost) {
        // followingFeedState?.addPostToFeedStart?.(newPost)
        nearbyFeedState?.addPostToFeedStart?.(newPost)
      }
    })
  }, [])

  return (
    <NearbyFeedContext.Provider value={{
      feedRef: nearbyFeedRef,
      feedState: nearbyFeedState,
      checkPostsButton: nearbyCheckPostsButton,
    }}>
      {children}
    </NearbyFeedContext.Provider>
  )
}

const useNearbyFeedContext = () => useContext(NearbyFeedContext)

export default useNearbyFeedContext

export { NearbyFeedContext, NearbyFeedProvider, useNearbyFeedContext }
